import { useEffect, useState } from "react";

/**
 * Hook to debounce a value with a specified delay.
 *
 * @template T The type of the value to debounce.
 * @param value The input value.
 * @param delay The delay in milliseconds before updating the debounced value (default : 400ms).
 * @returns The debounced value after the specified delay.
 */
export const useDebounce = <T>(value: T, delay = 400): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [value, delay]);

  return debouncedValue;
};
